import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CalendarDays } from "lucide-react";
import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";

export default function ComingSoon({ icon: Icon, title, text, testId }) {
  const { t } = useLanguage();
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-16" data-testid={testId}>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center max-w-md">
        <div className="w-20 h-20 rounded-3xl bg-coral/10 text-coral flex items-center justify-center mx-auto mb-6"><Icon size={36} /></div>
        <Badge className="rounded-full bg-golden/15 text-golden border-golden/30 mb-4 px-4 py-1">{t("coming.badge")}</Badge>
        <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tight mb-3">{t(title)}</h1>
        <p className="text-muted-foreground mb-8">{t(text)}</p>
        <Link to="/book"><Button className="rounded-full bg-coral hover:bg-coral-600 text-white gap-2 h-11 px-8"><CalendarDays size={16} /> {t("coming.book")}</Button></Link>
      </motion.div>
    </div>
  );
}
